import {
  Box,
  MenuItem,
  Popover,
  TextField,
  Typography,
} from "@mui/material";
import { CasLoader } from "../brand/CasLoader";
import { useSubscriptionSearch } from "../../hook/subscriptionSearch";
import { UseMenuProps } from "../../hook/menu";
import { SubscriptionSearchResult } from "../../types/subscriptionSearch";

export const SubscriptionSelectMenu: React.FC<
  UseMenuProps & {
    onChange: (subscription: SubscriptionSearchResult) => Promise<any>;
  }
> = ({ onChange, ...useMenuProps }) => {
  const { onClose, open } = useMenuProps;
  const { searchString, setSearchString, setIsLoading, isLoading, page } =
    useSubscriptionSearch({ disabledSearch: !open });

  return (
    <Popover {...useMenuProps}>
      <Box sx={{ p: 2, width: "20rem" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">Select Subscription</Typography>
          {isLoading && <CasLoader size={20} />}
        </Box>
        <TextField
          fullWidth
          value={searchString}
          onChange={(e) => setSearchString(e.currentTarget.value)}
          placeholder="Search subscriptions..."
          sx={{ mt: 2 }}
        />
        <Box sx={{ height: "10rem", overflowY: "auto", mt: 1 }}>
          {page.map((sub) => (
            <MenuItem
              key={`${sub["page-id"]}:${sub["block-id"]}`}
              onClick={() => {
                setIsLoading(true);
                onChange(sub).finally(() => {
                  setIsLoading(false);
                  onClose();
                });
              }}
            >
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="body2">{sub.name}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {sub["page-id"]}
                </Typography>
              </Box>
            </MenuItem>
          ))}
          {!isLoading && page.length === 0 && (
            <Typography variant="body2" color="text.secondary" sx={{ p: 1 }}>
              No subscriptions found
            </Typography>
          )}
        </Box>
      </Box>
    </Popover>
  );
};
